import * as awarenessProtocol from 'y-protocols/awareness';
import { collaborationSocket } from '../socket';

export const EVT_AWARENESS_UPDATE = 'awareness:update';

// Bridge a y-protocols/awareness instance to the collaboration socket.
//
// Returns:
//   - applyMembers(snapshot): apply the binary `members` payload from
//     the diagram:join ack (backend doc §4.2).
//   - destroy(): detach all listeners.
//
// Origin convention (backend doc §6.1): the socket instance itself is
// the origin marker for remote-applied awareness updates. The local
// change-listener skips updates whose origin is the socket so we don't
// echo remote frames back to the server.
export function setupSocketAwareness(awareness, opts = {}) {
    const socket = opts.socket || collaborationSocket;
    let destroyed = false;

    const handleLocalAwarenessUpdate = ({ added, updated, removed }, origin) => {
        if (origin === socket) return;
        const changedClients = added.concat(updated).concat(removed);
        if (changedClients.length === 0) return;
        const frame = awarenessProtocol.encodeAwarenessUpdate(awareness, changedClients);
        socket.emit(EVT_AWARENESS_UPDATE, frame);
    };
    awareness.on('update', handleLocalAwarenessUpdate);

    const handleInboundFrame = (frame) => {
        if (destroyed) return;
        try {
            const buf = frame instanceof Uint8Array ? frame : new Uint8Array(frame);
            awarenessProtocol.applyAwarenessUpdate(awareness, buf, socket);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('[socket-awareness] inbound frame failed', err);
        }
    };
    socket.on(EVT_AWARENESS_UPDATE, handleInboundFrame);

    function applyMembers(snapshot) {
        if (destroyed) return;
        if (!snapshot) return;
        const buf = snapshot instanceof Uint8Array ? snapshot : new Uint8Array(snapshot);
        awarenessProtocol.applyAwarenessUpdate(awareness, buf, socket);
    }

    function destroy() {
        if (destroyed) return;
        destroyed = true;
        awareness.off('update', handleLocalAwarenessUpdate);
        socket.off(EVT_AWARENESS_UPDATE, handleInboundFrame);
    }

    return { applyMembers, destroy };
}
